const displayCurrencyNumber = (num: number, zeroes = 2) => {
	return (Math.round(num * 100) / 100)
		.toFixed(zeroes)
		.toString()
		.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export default displayCurrencyNumber;
